import React from 'react';
import { Undo } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { MenuButton } from './menu-button';

export const UndoButton = () => {
  const { editor, disabled } = useRichTextEditor();

  const isDisabled = disabled || !editor.can().chain().focus().undo().run();
  const onClick = () => editor.chain().focus().undo().run();
  const variant = editor.isActive('undo') ? 'filled' : 'transparent';

  return (
    <MenuButton onClick={onClick} disabled={isDisabled} variant={variant} aria-label='undo'>
      <Undo />
    </MenuButton>
  );
};
